function _typeof(obj) { "@babel/helpers - typeof"; if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") { _typeof = function _typeof(obj) { return typeof obj; }; } else { _typeof = function _typeof(obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }; } return _typeof(obj); }

function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

function _defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } }

function _createClass(Constructor, protoProps, staticProps) { if (protoProps) _defineProperties(Constructor.prototype, protoProps); if (staticProps) _defineProperties(Constructor, staticProps); return Constructor; }

function _possibleConstructorReturn(self, call) { if (call && (_typeof(call) === "object" || typeof call === "function")) { return call; } return _assertThisInitialized(self); }

function _getPrototypeOf(o) { _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) { return o.__proto__ || Object.getPrototypeOf(o); }; return _getPrototypeOf(o); }

function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }

function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function"); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, writable: true, configurable: true } }); if (superClass) _setPrototypeOf(subClass, superClass); }

function _setPrototypeOf(o, p) { _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) { o.__proto__ = p; return o; }; return _setPrototypeOf(o, p); }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faBarcode, faPlus } from '@fortawesome/free-solid-svg-icons';
import Swipeout from 'rc-swipeout';
import { Input } from '../../../Input';
import USABMX from '../../../../services/USABMX';
import './RiderSelector.css';

var RiderSelector = /*#__PURE__*/function (_React$Component) {
  _inherits(RiderSelector, _React$Component);

  function RiderSelector(props) {
    var _this;

    _classCallCheck(this, RiderSelector);

    _this = _possibleConstructorReturn(this, _getPrototypeOf(RiderSelector).call(this, props));

    _defineProperty(_assertThisInitialized(_this), "updateRiderList", function () {
      var storage = _this.props.storage;
      storage.riders().then(function (riders) {
        _this.setState({
          riders: riders
        });
      });
    });

    _defineProperty(_assertThisInitialized(_this), "selectRider", function (e, rider) {
      var _this$props = _this.props,
          logBookEntry = _this$props.logBookEntry,
          entry = _this$props.entry,
          onSelect = _this$props.onSelect;
      entry.rider = rider;
      onSelect(e, logBookEntry);
    });

    _defineProperty(_assertThisInitialized(_this), "scanCard", function () {
      var storage = _this.props.storage;
      cordova.plugins.barcodeScanner.scan(function (result) {
        if (!result.cancelled && result.text && result.format) {
          var serial = result.text;

          if (serial.trim() !== '') {
            storage.getRiderInfoBySerial(serial).then(function (info) {
              storage.getRiderBySerial(serial).then(function (rider) {
                _this.setState({
                  riderName: ''
                }, function () {
                  _this.selectRider(undefined, rider);
                });
              }).catch(function (err) {
                console.error(err);
              });
            });
          }
        }
      }, function (error) {
        console.error(error);
      }, {
        preferFrontCamera: false,
        // iOS and Android
        showFlipCameraButton: true,
        // iOS and Android
        showTorchButton: true,
        // iOS and Android
        torchOn: true,
        // Android, launch with the torch switched on (if available)
        saveHistory: true,
        // Android, save scan history (default false)
        prompt: "Place a USA BMX membership card inside the scan area",
        // Android
        resultDisplayDuration: 500,
        // Android, display scanned text for X ms. 0 suppresses it entirely, default 1500
        disableAnimations: false,
        // iOS
        disableSuccessBeep: false // iOS and Android

      });
    });

    _defineProperty(_assertThisInitialized(_this), "changeValue", function (event) {
      var value = event.target.value;

      _this.setState({
        riderName: value
      });
    });

    _defineProperty(_assertThisInitialized(_this), "handleKeyPress", function (event) {
      var storage = _this.props.storage;

      if (event.which === 13) {
        event.target.blur();
        storage.findRiderByName(_this.state.riderName.trim()).then(function (riders) {
          var rider = riders && riders[0];

          if (rider) {
            _this.setState({
              riderName: ''
            }, function () {
              _this.selectRider(undefined, rider);
            });
          } else {
            storage.addRider(_this.state.riderName.trim()).then(function (rider) {
              storage.riders().then(function (riders) {
                _this.setState({
                  riders: riders,
                  riderName: ''
                }, function () {
                  _this.selectRider(undefined, rider);
                });
              });
            });
          }
        });
      }
    });

    _defineProperty(_assertThisInitialized(_this), "deleteRider", function (rider) {
      var _this$props2 = _this.props,
          storage = _this$props2.storage,
          updateLogBook = _this$props2.updateLogBook;
      storage.deleteRiderById(rider.id).then(function () {
        var riders = _this.state.riders;
        riders.splice(riders.indexOf(rider), 1);

        _this.setState({
          riders: riders.slice()
        }, function () {
          updateLogBook();
        });
      }, function (error) {
        console.error(error);
      });
    });

    _this.state = {
      riderName: '',
      riders: []
    };
    return _this;
  }

  _createClass(RiderSelector, [{
    key: "componentDidMount",
    value: function componentDidMount() {
      var updateRiderList = this.updateRiderList;
      updateRiderList();
    }
  }, {
    key: "componentDidUpdate",
    value: function componentDidUpdate(prevProps, prevState) {
      var updateRiderList = this.updateRiderList;

      if (prevProps.activePanel !== this.props.activePanel) {
        updateRiderList();
      }
    }
  }, {
    key: "render",
    value: function render() {
      var addRider = this.addRider,
          deleteRider = this.deleteRider,
          selectRider = this.selectRider,
          scanCard = this.scanCard,
          changeValue = this.changeValue,
          handleKeyPress = this.handleKeyPress;
      var _this$props3 = this.props,
          app = _this$props3.app,
          width = _this$props3.width,
          height = _this$props3.height,
          logBookEntry = _this$props3.logBookEntry,
          entry = _this$props3.entry;
      var riders = this.state.riders;
      return React.createElement("div", {
        className: "rider-selector",
        style: {
          height: "".concat(height, "px")
        }
      }, React.createElement("div", {
        className: "header"
      }, React.createElement("div", {
        className: "name-input"
      }, React.createElement(Input, {
        label: "Enter a new Rider's Name",
        locked: false,
        active: false,
        type: "text",
        onChange: changeValue,
        onKeyPress: handleKeyPress,
        value: this.state.riderName
      })), React.createElement("div", {
        className: "btn ripple",
        onClick: scanCard
      }, React.createElement(FontAwesomeIcon, {
        icon: faBarcode
      }))), React.createElement("div", {
        className: "riders",
        style: {
          height: "".concat(height - 50 - 45, "px")
        }
      }, riders.length === 0 && React.createElement("div", {
        className: "rider",
        key: 'no-riders-found'
      }, React.createElement("div", {
        className: "name"
      }, "no riders found")), riders.map(function (rider) {
        return React.createElement(Swipeout, {
          key: rider.id.toString(),
          autoClose: true,
          right: [{
            text: 'delete',
            onPress: function onPress(e) {
              deleteRider(rider);
            },
            style: {
              backgroundColor: 'rgba(var(--danger-color), .5)',
              color: 'rgba(var(--foreground-color), 1)'
            }
          }]
        }, React.createElement("div", {
          className: "rider ripple ".concat(rider.id === entry.rider.id ? 'selected' : ''),
          key: rider.id.toString(),
          onClick: function onClick(e) {
            return selectRider(e, rider);
          }
        }, React.createElement("div", {
          className: "name"
        }, rider.name)));
      })));
    }
  }]);

  return RiderSelector;
}(React.Component);

export default RiderSelector;